import * as React from 'react';

import {Typography} from '@mui/material';

import './hoa-error-message.scss';

interface IErrorMessageProps {
	errorHeader?: string;
	errorText?: string;
}

export default class ErrorMessage extends React.Component<IErrorMessageProps, {}> {
	public render() {
		return (
			<div key='loading-background-image' className='loadingBackground'>
				<div className='errorPageStyle'>
					<Typography variant='h4'>
						{this.props.errorHeader}
					</Typography>
					<Typography variant='body2'>
						{this.props.errorText}
					</Typography>
				</div>
			</div>
		);
	}
}
